import type { MailDiagResultDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MailDiagnosticsService {
  apiName = 'Default';
  

  send = (to: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/mail-diagnostics/send',
      params: { to },
    },
    { apiName: this.apiName,...config });
  

  send2 = (to: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, MailDiagResultDto>({
      method: 'POST',
      url: '/api/app/mail-diagnostics/send2',
      params: { to },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
